var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIbmCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ibm-cloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5805,13.65A9.7327,9.7327,0,0,0,6.286,17.5387,6.75,6.75,0,0,0,7,31H23a8.7465,8.7465,0,0,0,1.5805-17.35ZM23,29.5H7a5.2373,5.2373,0,0,1-.6993-10.4293,9.7265,9.7265,0,0,0,1.1036,3.7838.75.75,0,1,0,1.3213-.709A8.25,8.25,0,0,1,22.752,13.5133a8.754,8.754,0,0,0-6.315,2.95.75.75,0,1,0,1.1245.9922A7.25,7.25,0,1,1,23,29.5Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8983,10.2548a.7582.7582,0,0,0-1.0364-.2776l-3.02,1.7438A.7587.7587,0,1,0,28.6,13.035l3.02-1.7438A.7589.7589,0,0,0,31.8983,10.2548Z",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6764,7.87a.7583.7583,0,0,0,1.0364-.2776l1.7438-3.02a.7587.7587,0,0,0-1.314-.7588l-1.7438,3.02A.7588.7588,0,0,0,22.6764,7.87Z",
    transform: "translate(0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6.0811a.759.759,0,0,0,.7588-.7588V1.8347a.7588.7588,0,1,0-1.5175,0V5.3223A.7589.7589,0,0,0,16,6.0811Z",
    transform: "translate(0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2873,7.5922a.7587.7587,0,0,0,1.314-.7588l-1.7438-3.02a.7587.7587,0,1,0-1.314.7588Z",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1585,11.721l-3.02-1.7438a.7587.7587,0,1,0-.7588,1.314L3.4,13.035a.7587.7587,0,1,0,.7588-1.314Z",
    transform: "translate(0)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    className: "cls-1",
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIbmCloud);
export default __webpack_public_path__ + "static/media/icon_ibm_cloud.fd0db6fdbea06418eac8698e13fdf5e6.svg";
export { ForwardRef as ReactComponent };